// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nYpSS","headingMovedDown":"styles_headingMovedDown__LhE0u","inlineLink":"styles_inlineLink__cdVcN"};